{
  "admins": {
    "errors": {
      "add": "Не удалось добавить администратора.",
      "notFound": "Не удалось найти этого администратора."
    }
  },
  "home": {
    "goToSandbox": "Перейти в песочницу",
    "subtitle": "Этот репозиторий является отправной точкой для создания веб-приложений с React, shadcn-ui и TanStack Router.",
    "title": "Добро пожаловать в шаблон React от Mindsea."
  },
  "login": {
    "errors": {
      "invalidEmail": "Пожалуйста, введите действительный адрес электронной почты.",
      "unauthorized": "У вас нет прав доступа к этому приложению."
    },
    "placeholder": "name@example.com",
    "sendCode": "Отправить код",
    "subtitle": "Создайте страницу входа здесь.",
    "title": "Войти"
  }
}
